import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  title: {
    margin: 0,
    marginLeft: 5,
  },
  materielRightHeader: {
    "& button": {
      padding: "8px !important",
    },
  },
  materielHeader: {
    padding: "6px !important",
  },
  dialogContent: {
    textAlign: "center",
  },
  cartContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: theme.spacing(4),
  },
  textButton: {
    backgroundColor: "transparent !important",
    border: "1px solid rgba(0, 0, 0, 0.23) !important",
    color: "black !important",
    "&:hover": {
      backgroundColor: `${theme.color.gray1} !important`, // light gray hover
    },
    "&:focus": {
      backgroundColor: `${theme.color.gray1} !important`,
    },
  },
}));
